import firebase from 'firebase/app';
import 'firebase/firestore';

export const collectionOptions = {
  snapshotListenOptions: {
    includeMetadataChanges: true
  }
}

const firebaseConfig = {
  apiKey: "AIzaSyD6vOxI4Vhp-ZoQRh1qoFCIJGd_T4pygh0",
  authDomain: "iamas-open-house-2021.firebaseapp.com",
  projectId: "iamas-open-house-2021",
  storageBucket: "iamas-open-house-2021.appspot.com",
  messagingSenderId: "414657488717",
  appId: "1:414657488717:web:6d521635582192d647b904",
  measurementId: "G-B6C7L79Q1M"
};

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
// db.useEmulator("localhost", 8080)
export default db;
